import { render, staticRenderFns } from "./DesignPublicationType.vue?vue&type=template&id=51c6cd70&"
import script from "./DesignPublicationType.vue?vue&type=script&lang=js&"
export * from "./DesignPublicationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports